import axios from "axios";

// axios.defaults.baseURL = "http://127.0.0.1:8000/api";
axios.defaults.baseURL = "https://variant-backend.developnetwork.net/api";



export default axios;


